import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from '@apollo/client';
export var pageBySlug = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query pageBySlug($slug: String!) {\n    pageBySlug(slug: $slug) {\n      content\n      title\n    }\n  }\n"])));